// Unpublished Work © 2020-2025 Deere & Company.

import {CustomerSearch} from '../../state/struct/customer-search/customer-search';
import * as actions from '../../action-list';
import {Customers} from '../../state/struct/customer';

const setCustomerSearch = (state, action) => Customers.update(state, {
    $set: action.customers
});

const updateMembership = (state, action) => {
    const customerIndex = state.findIndex((item) => item.entityId === action.entityId && item.contactId === action.contactId);

    return Customers.update(state, {
        [customerIndex]: {
            $merge: {
                selectedDBS: action.value
            }
        }
    });
};

const updateCustomerOrgSelection = (state, action) => {
    const customerIndex = state.findIndex((item) => item.entityId === action.entityId && item.contactId === action.contactId);

    if (customerIndex === -1) {
        return state;
    }

    return Customers.update(state, {
        [customerIndex]: {
            $merge: {
                selectedOrganization: action.orgId
            }
        }
    });
};

const filterCustomerSearchByContactId = (state, action) => {
    const filteredCustomers = state.filter((customer) => action.contactId !== customer.contactId);

    return filteredCustomers.length > 0 ? filteredCustomers : [];
};

const filterCustomerSearchByEntityId = (state, action) => {
    const filteredCustomers = state.filter((customer) => action.entityId !== customer.entityId);

    return filteredCustomers.length > 0 ? filteredCustomers : [];
};

export const customers = (state = new CustomerSearch({}).customers, action = {}) => {
    const actionHandlers = {
        [actions.SET_CUSTOMER_SEARCH_LIST]: setCustomerSearch,
        [actions.UPDATE_MEMBERSHIP]: updateMembership,
        [actions.UPDATE_CUSTOMER_ORG_SELECTION]: updateCustomerOrgSelection,
        [actions.FILTER_CUSTOMER_SEARCH_BY_CONTACT_ID]: filterCustomerSearchByContactId,
        [actions.FILTER_CUSTOMER_SEARCH_BY_ENTITY_ID]: filterCustomerSearchByEntityId
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
